/**
 * Title and search engine indexing of the app.
 * Vanilla uses hash routing, so search engines only see the start page (it leads guests to the login).
 * Only the login of the production client may be indexed, every other page and every other host gets noindex.
 * public/index.html sets the same rule before the app has loaded (keep both in sync).
 */
export const APP_TITLE = 'mymusicschool';

/** Hosts whose login may appear in search results (testing and local stay noindex) */
export const INDEXABLE_HOSTS = ['vanilla.mymusicschool.de'];

/** Routes that may appear in search results */
export const INDEXABLE_PATHS = ['/login'];

export const ROBOTS_INDEX = 'index, follow';
export const ROBOTS_NOINDEX = 'noindex, nofollow';

export function robotsContentFor(path: string, hostname: string): string {
    return INDEXABLE_HOSTS.includes(hostname) && INDEXABLE_PATHS.includes(path) ? ROBOTS_INDEX : ROBOTS_NOINDEX;
}

/** Writes the robots meta tag for the given route (creates it if index.html has none) */
export function applyRobotsMeta(path: string) {
    if (typeof document === 'undefined') {
        return;
    }
    let tag = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!tag) {
        tag = document.createElement('meta');
        tag.name = 'robots';
        document.head.appendChild(tag);
    }
    const content = robotsContentFor(path, window.location.hostname);
    if (tag.content !== content) {
        tag.content = content;
    }
}
